/* User defined models */
import { PoliticalUnit } from './politicalUnit';


export class State extends PoliticalUnit {
    lat?: string;
    long?: string;

  constructor(
    id: string,
    name: string,
    uri?: string,
    lat?: string,
    long?: string
  ) {
    super(id, name, uri);
    this.lat = lat;
    this.long = long;
  }
}
